export const masterItems = [
  {
    category: "Modular Kitchen",
    description: "Modular kitchen - Providing and installing a custom-designed Modular Kitchen Unit with HDHMR carcase (brand: Action Tesa, Greenlam) and MDF shutters (brand: Century, Greenpanel). Shutters are finished with laminate (brand: Merino, Century, Virgo) and feature profile handles. All fittings are Innotech series (Kolt/Stylus/Ebco/Haffele) with soft-close hardware for smooth operation.",
    rate: 1400
  },
  {
    category: "Modular Kitchen",
    description: "Overhead cabinet kitchen - Providing and installing custom-designed Kitchen Overhead Cabinets with HDHMR carcase (brand: Action Tesa, Greenlam) and MDF shutters (brand: Century, Greenpanel). Shutters are finished with laminate (brand: Merino, Century, Virgo) and feature profile handles.",
    rate: 1200
  },
  {
    category: "Civil Work",
    description: "False Ceiling - Gypsum Board False ceiling with GI framing (Brand - Saint Gobain / Gyproc). It includes finishing with joint tape and compound. (Does not include electrical wiring and lights).",
    rate: 125
  },
  {
    category: "Civil Work",
    description: "Cove - Making of cove for strip light in false ceiling. It includes finishing with joint tape and compound.",
    rate: 90
  },
  {
    category: "Civil Work",
    description: "Pelmet - Making of pelmet for curtains in false ceiling / Boxing for hiding AC pipe / rod. It includes finishing with joint tape and compound.",
    rate: 90
  },
  {
    category: "Painting",
    description: "Painting - Good quality LUSTER Painting work. Involves Sanding, application of primer, putty, fine sanding, second hand of primer & 2 coats of Paint. Rate includes all labour & material. Brand used - Asian Paints - royal",
    rate: 28
  },
  {
    category: "Wood Work",
    description: "Chaukhat - Providing and fixing Marandi wood chaukhat (frame) of size 6\" x 2.5\".",
    rate: 8500
  }
];